export const campaignTypeOptions = [
  { id: 'standard', text: 'Standard' },
  { id: 'sponsorship', text: 'Sponsorship' },
  { id: 'takeover', text: 'Takeover' }
];

export const currencyOptions = [
  { id: 'usd', text: 'USD' },
  { id: 'egp', text: 'EGP' },
  { id: 'lbp', text: 'LBP' }
];
